export const getDiscordAuthURL = () => {
  const functionURL =
    "https://europe-west1-world-of-gamers-d663f.cloudfunctions.net/discordAuth";
  const encoded = encodeURIComponent(functionURL);
  return `https://discord.com/oauth2/authorize?client_id=1290248355057766423&response_type=code&redirect_uri=${encoded}&scope=identify+email+guilds.join`;
};
